import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermsValue } from '../../../packages/JsonQuery';
import { EConditionType } from '../../../packages/JsonQuery/types/conditionType';
import { EConditionTypeLegacy } from '../../../packages/api-models/common/json_query';

const LEGACY_TO_UI: Partial<Record<EConditionTypeLegacy, EConditionType>> = {
  [EConditionTypeLegacy.OfficeDecoration]: EConditionType.OfficeDecoration,
  [EConditionTypeLegacy.FullDecorationNeeded]: EConditionType.FullDecorationNeeded,
  [EConditionTypeLegacy.MajorRepairNeeded]: EConditionType.MajorRepairNeeded,
  [EConditionTypeLegacy.CosmeticRepairNeeded]: EConditionType.CosmeticRepairNeeded,
  [EConditionTypeLegacy.RegularRepair]: EConditionType.RegularRepair,
  [EConditionTypeLegacy.DesignerRepair]: EConditionType.DesignerRepair,
};

export const selectConditionType = createSelector(selectJsonQuery, jsonQuery => {
  const office = (getTermsValue('condition_type')(jsonQuery) ?? []) as EConditionTypeLegacy[];
  const trade = (getTermsValue('condition_type__free_appointment_object')(jsonQuery) ?? []) as EConditionTypeLegacy[];
  const industry = (getTermsValue('condition_type__industry')(jsonQuery) ?? []) as EConditionTypeLegacy[];

  const merged = new Set<EConditionType>();

  for (const value of [...office, ...trade, ...industry]) {
    const ui = LEGACY_TO_UI[value];
    if (ui !== undefined) {
      merged.add(ui);
    }
  }

  return merged.size > 0 ? Array.from(merged) : null;
});
